import React from "react";

import { faArrowLeft, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Button, Col, Container, Row } from "react-bootstrap";

import useContactContext from "../../../hooks/useContactContext";
import i18n from "../../../i18n";

const ContactFormFooter = (): React.JSX.Element => {
  const { t } = i18n;
  const {
    submitting,
    setCategory,
    methods,
    onSubmit,
    hasError,
    totalFailedAttempts,
  } = useContactContext();

  return (
    <Container className="contactFormFooter">
      <Row>
        {hasError && totalFailedAttempts < 11 ? (
          <Col xs={12}>
            <Alert variant="danger">{t("form.failed")}</Alert>
          </Col>
        ) : null}

        {totalFailedAttempts > 10 && (
          <Col xs={12}>
            <Alert variant="danger">
              {t(
                "Too many failed attempts. Please reload the page, and try again. If the issue continues, contact us at ",
              )}
              <a href="mailto:support@pakville.ca" rel="noreferrer">
                support@pakville.ca
              </a>
            </Alert>
          </Col>
        )}

        <Col
          className="d-flex p-3 justify-content-between align-items-center gap-4"
          xs={12}
        >
          <Button
            className="d-flex justify-content-center align-items-center gap-2 p-2 ps-5 pe-5"
            disabled={submitting}
            onClick={() => setCategory()}
            variant="outline-primary"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            {t("Back")}
          </Button>

          {totalFailedAttempts > 10 ? (
            <Button disabled className="p-2 ps-5 pe-5" variant="secondary">
              {t("submit")}
            </Button>
          ) : (
            <React.Fragment>
              {submitting ? (
                <Button className="p-2 ps-5 pe-5" variant="secondary">
                  <FontAwesomeIcon spin icon={faSpinner} />
                </Button>
              ) : (
                <Button
                  className="p-2 ps-5 pe-5"
                  disabled={!methods.formState.isDirty}
                  onClick={() => onSubmit(methods.getValues())}
                  type="submit"
                  variant="primary"
                >
                  {t("submit")}
                </Button>
              )}
            </React.Fragment>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default ContactFormFooter;
